import { menu } from './core/menu/menu';
import { LayoutComponent } from './shared/layout/layout.component';
var ɵ0 = function () { return import("./panel/panel.module.ngfactory").then(function (m) { return m.PanelModuleNgFactory; }); };
export var routes = [
    { path: "", redirectTo: "login", pathMatch: "full" },
    {
        path: "",
        component: LayoutComponent,
        loadChildren: ɵ0
    },
    // 404 Not found
    { path: "**", redirectTo: "not-found" }
];
var RoutesModule = /** @class */ (function () {
    function RoutesModule(menuService, tr, settings) {
        this.menuService = menuService;
        this.settings = settings;
        this.settings.isLightVersion$.subscribe(function (lightVersion) {
            if (lightVersion)
                menuService.addMenu(menu.filter(function (f) { return f.lightVersion == lightVersion; }));
            else
                menuService.addMenu(menu);
        });
    }
    return RoutesModule;
}());
export { RoutesModule };
export { ɵ0 };
